/** User settings section identifiers. */
export const USER_SETTINGS_SECTIONS = {
    PROFILE: 'profile',
    SECURITY: 'security',
    EMAIL: 'email-preferences',
};
